import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select';
import { Spinner } from 'reactstrap';

const days = require('../../data/weekdays.json')

const SelectWeekDays = ({
   initialValues = [],
   onChange = (values) => {},
   isDisabled = false,
   resetValue = false
}) => {
    const [loading, setLoading] = useState(false)
    const [values, setValues] = useState(null)


    const isMounted = useRef(true)



    //Actualizar la referencia
    useEffect(()=>{
        return ()=>{ isMounted.current = false }
    },[])



    //Actualizar los items seleccionados cuando se manipulan desde fuera
    /*useEffect(() => {
        if(!values || values.length ===  0) return;

        const items = values.filter(i => initialValues.some(iv => iv.id === i.id));

        setValues(items)
    }, [ initialValues ])*/


    // cargar los items default
    useEffect(() => {
        const items = days.filter(i => initialValues.some(iv => iv?.id === i.id));

        setValues(items)
    }, [ initialValues ])




    const onSelectedDayChange = selectedOptions => {
        setValues(selectedOptions);
        onChange(selectedOptions);
    };



    return <Select
        isMulti
        value={ values }
        name={'days'}
        options={ days }
        onChange={ onSelectedDayChange }
    />
}

export default SelectWeekDays